// src/components/WarRoomInvitations.js
//
// 6a-04 (2026-09-14, task list section 230; ruling 131). The invitee's side of the War Room: the
// occasions this account is invited to, on his desk - "only invitees may be present" (ruling 17), and an
// invitee is present by recording it. The query is the one the read rule can prove (inviteeUids
// array-contains me). Nothing else about the War Room is visible to him.
import React, { useEffect, useMemo, useState } from 'react';
import { db } from '../firebase';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { partitionSessions } from '../data/warRoom';
import { OccasionCard } from '../pages/WarRoom';
import RulingRef from './RulingRef';   // ruling 168: the number behind Why? for a member, [R-nn] for an officer

const C = { panel: '#0B1626', line: '#2E4A6B', dim: '#8AA4BF', accent: '#E8A020', bad: '#E06C6C', ok: '#5FB878', text: '#DCE7F2' };

export default function WarRoomInvitations({ user }) {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState('');
  useEffect(() => {
    if (!user || !user.uid) return undefined;
    const q = query(collection(db, 'warRoomSessions'), where('inviteeUids', 'array-contains', user.uid));
    const unsub = onSnapshot(q, snap => { setRows(snap.docs.map(d => ({ id: d.id, ...d.data() }))); setErr(''); },
      e => { setErr('Invitations could not be read: ' + (e && e.code ? e.code : e.message)); setRows([]); });
    return () => unsub();
  }, [user && user.uid]);
  const p = useMemo(() => partitionSessions(rows || []), [rows]);
  return (
    <div style={{ border: '1px solid ' + (p.open.length ? C.accent : C.line), background: C.panel, marginBottom: 14 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', padding: '10px 14px', borderBottom: '1px solid ' + C.line }}>
        <div>
          <div style={{ fontSize: 13, fontWeight: 700, color: C.text }}>War Room - occasions you are invited to</div>
          <div style={{ fontSize: 11, color: C.dim, marginTop: 2 }}>The General Chairperson's meeting room, where only invitees may be present. Invitation is per occasion. Record your presence when you are in the room.<RulingRef user={user} n={17} why="The War Room is the General Chairperson's meeting room; invitation is per occasion." /></div>
        </div>
        <div style={{ fontSize: 12, fontWeight: 700, color: p.open.length ? C.accent : C.ok, whiteSpace: 'nowrap' }}>{rows === null ? '…' : p.open.length + ' convened'}</div>
      </div>
      <div style={{ padding: '8px 14px 12px', fontSize: 12, color: C.dim }}>
        {err ? <div style={{ color: C.bad }}>&#9888; {err}</div> : null}
        {rows && rows.length === 0 && !err ? <div>No invitation is on record.</div> : null}
        {p.open.map(s => <OccasionCard key={s.id} s={s} user={user} />)}
        {p.closed.length ? <details><summary style={{ cursor: 'pointer' }}>{p.closed.length} closed</summary>{p.closed.map(s => <OccasionCard key={s.id} s={s} user={user} />)}</details> : null}
      </div>
    </div>
  );
}
